import React from "react";

const HowItWorks = () => {
  return (
    <div className="mt-10 max-w-screen-lg mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-between">
      {/* Header Section */}
      <div className="text-center">
        <h3 className="text-3xl sm:text-5xl leading-normal font-extrabold tracking-tight text-gray-900">
          How It <span className="text-cyan-900">Works</span>
        </h3>
        <p className="mt-4 text-lg leading-7 text-gray-500 font-medium">
          It’s as Easy as 1-2-3!
        </p>
      </div>

      {/* Steps Section */}
      <div className="mt-20">
        <ul className="md:grid md:grid-cols-3 md:gap-10">
          {/* Step 1 */}
          <li className="bg-gray-100 p-5 pb-10 text-center rounded-lg shadow-md">
            <div className="flex flex-col items-center">
              <div className="flex-shrink-0 relative top-0 -mt-16">
                <div className="flex items-center justify-center h-20 w-20 rounded-full bg-cyan-900 text-white border-4 border-white text-xl font-semibold">
                  1
                </div>
              </div>
              <div className="mt-4">
                <h4 className="text-lg leading-6 font-semibold text-gray-900">
                  Hire Us
                </h4>
                <p className="mt-2 text-base leading-6 text-gray-500">
                  Complete our simple online form to get started.
                </p>
              </div>
            </div>
          </li>

          {/* Step 2 */}
          <li className="bg-gray-100 p-5 pb-10 text-center rounded-lg shadow-md">
            <div className="flex flex-col items-center">
              <div className="flex-shrink-0 relative top-0 -mt-16">
                <div className="flex items-center justify-center h-20 w-20 rounded-full bg-cyan-900 text-white border-4 border-white text-xl font-semibold">
                  2
                </div>
              </div>
              <div className="mt-4">
                <h4 className="text-lg leading-6 font-semibold text-gray-900">
                  Submit Photos
                </h4>
                <p className="mt-2 text-base leading-6 text-gray-500">
                  Snap a few photos of the vehicle parked on your pavement.
                </p>
              </div>
            </div>
          </li>

          {/* Step 3 */}
          <li className="bg-gray-100 p-5 pb-10 text-center rounded-lg shadow-md">
            <div className="flex flex-col items-center">
              <div className="flex-shrink-0 relative top-0 -mt-16">
                <div className="flex items-center justify-center h-20 w-20 rounded-full bg-cyan-900 text-white border-4 border-white text-xl font-semibold">
                  3
                </div>
              </div>
              <div className="mt-4">
                <h4 className="text-lg leading-6 font-semibold text-gray-900">
                  We Handle the Rest
                </h4>
                <p className="mt-2 text-base leading-6 text-gray-500">
                  Our experienced team takes care of all the legal steps to bring you results.
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>

      {/* Footer Text */}
      <div className="text-center mt-10">
        <p className="text-gray-500 text-base">
          Parking on pavements not only breaks guidelines but also poses risks. Let us make it effortless for you to take back your space.
        </p>
      </div>
    </div>
  );
};

export default HowItWorks;
